const Joi = require('joi')
const fields = require('../fields')

const getUserItemsSchema = Joi.object({
    userId: fields.objectIdField.required().label('User ID'),
    itemCollectionId: fields.objectIdField.required().label('Item Collection ID'),
});

module.exports = getUserItemsSchema;